export class Footer {
  constructor() {
    // Look for plain text email addresses in the form "name [at] example [dot] com" in the footer and convert them to mailto links
    const footer = document.querySelector('footer');
    if (footer) {

      // Look for spam protected plain text email addresses of the form "name [at] example [dot] com"
      // and convert them to mailto links

      const emailRegex = /([a-zA-Z0-9._%+-]+)\s*\[at]\s*([a-zA-Z0-9.-]+)\s*\[dot]\s*([a-zA-Z]{2,})/g;

      footer.innerHTML = footer.innerHTML.replace(emailRegex, (_, p1, p2, p3) => {
        const email = `${p1}@${p2}.${p3}`;
        return `<a href="mailto:${email}">${email}</a>`;
      });

      // Also look for phone number and convert to a tel link
      const phoneRegex = /(\+44[^\<]*)/g;
      footer.innerHTML = footer.innerHTML.replace(phoneRegex, (match) => {
        return `<a class="no-underline sr-only" href="tel:${match}">${match}</a>`;
      });
    }
  }
}
